if (!window.Eurus.loadedScript.has('variant-select.js')) {
  window.Eurus.loadedScript.add('variant-select.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelect', (
        element,
        sectionId,
        isProductPage,
        unavailableText,
        productUrl,
        cloneSectionId = element.closest('.data-id-section-card') ? element.closest('.data-id-section-card').id : ''
      ) => ({
        loadingEls: '',
        currentVariant: {},
        cachedResults: [],
        handleSectionId: sectionId,
        mediaGallerySource: [],
        optionConnects: [],
        mediaOption: "",
        handleSticky: '',
        initfirstMedia: false,
        _dispatchVariantSelected(html) {
          window.requestAnimationFrame(() => {
            setTimeout(() => { this.loadingEls = ''; }, 100);
          })
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select:updated:${sectionId}`, {
            detail: { html: html }
          }));
        },
        _dispatchUpdateVariant(html="") {
          document.dispatchEvent(new CustomEvent(`eurus:product-card-variant-select:updated:${sectionId}`, {
            detail: {
              currentVariant: this.currentVariant,
              html: html
            }
          }));
        },
        _renderDestination(html, selector) {
          const destination = document.getElementById(selector + sectionId);
          const source = html.getElementById(selector + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _goToSelectedVariantMedia() {
          let splideEl = document.getElementById("x-product-" + sectionId);
          let slideVariant = ""
          let index = ""
          let activeEL = ""
          if (this.currentVariant !== undefined && this.currentVariant.featured_media !== undefined) {
            slideVariant = document.getElementsByClassName(this.currentVariant.featured_media.id + '-' + sectionId);
            index = parseInt(slideVariant[0]?.getAttribute('index'));
            activeEL = document.getElementById('postion-image-' + sectionId + '-' + this.currentVariant.featured_media.id);
          } else {
            slideVariant = splideEl.querySelector(".featured-image");
            index = parseInt(slideVariant?.getAttribute('index'));
            activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
          }
          
          if (splideEl) {
            if (splideEl.splide && slideVariant) {
              splideEl.splide.go(index)
            } else {
              document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
                if (splideEl.splide)
                  splideEl.splide.go(index);
              });
            }
          }

          return activeEL;
        },
        _updateMedia(html) {
          // Remove old variant images first
          this._removeVariantImages();
          
          let mediaWithVariantSelected = document.getElementById("product-media-" + sectionId) && document.getElementById("product-media-" + sectionId).dataset.mediaWithVariantSelected;
          
          if (!mediaWithVariantSelected) {
            let activeEL = this._goToSelectedVariantMedia();
            if (!activeEL) return;

            if (html && !mediaWithVariantSelected) {
              let mediaGalleryDestination = html.getElementById(`stacked-${ sectionId }`);
              let mediaGallerySource = document.getElementById(`stacked-${ sectionId }`);

              if (mediaGallerySource && mediaGalleryDestination) {
                let firstChildSource = mediaGallerySource.querySelectorAll('div[data-media-id]')[0];
                let firstChildDestination = mediaGalleryDestination.querySelectorAll('div[data-media-id]')[0];
                if (firstChildDestination.dataset.mediaId != firstChildSource.dataset.mediaId && firstChildSource.dataset.index != 1) {
                  let sourceIndex = parseInt(firstChildSource.dataset.index);  
                  let positionOld = mediaGallerySource.querySelector(`div[data-media-id]:nth-of-type(${sourceIndex + 1})`);
                  mediaGallerySource.insertBefore(firstChildSource, positionOld);
                }

                // Spread variant images instead of using slider
                this._spreadVariantImages(activeEL);
                
                // Add extra media to mobile slider
                this._addExtraMediaToMobileSlider();
                
                mediaGallerySource.prepend(activeEL);
              }
            }
          }
          if (mediaWithVariantSelected) {
            this.updateMultiMediaWithVariant();
          }
        },
        _spreadVariantImages(container) {
          // Remove any existing variant images from other containers
          const stackedContainer = document.getElementById(`stacked-${sectionId}`);
          if (!stackedContainer || !container) return;

          // Check if currentVariant exists
          if (!this.currentVariant) {
            this._hideNonVariantImages();
            return;
          }

          // Remove previously added variant images (only dynamically added ones, not the main container)
          const existingVariantImages = stackedContainer.querySelectorAll('[data-variant-image="true"]:not([data-media-id])');
          existingVariantImages.forEach(el => el.remove());
 
          // Mark the main variant image container
          container.setAttribute('data-variant-image', 'true'); 

          // Get the media index for positioning
          const currentIndex = parseInt(container.getAttribute('data-index')) || 1;
          let insertIndex = currentIndex;
          const extraMedia = this.currentVariant && this.currentVariant.metafields && this.currentVariant.metafields.extra_media_files;

          // Add extra media files if they exist in variant metafields
            if (extraMedia && Array.isArray(extraMedia)) {
              extraMedia.forEach((media, index) => {
              // Create a new media item similar to product media items
              const mediaItem = document.createElement('div');
              mediaItem.className = 'product-media-item w-[calc(50%-5px)] postion-image-variant';
              mediaItem.setAttribute('data-variant-image', 'true');
              mediaItem.setAttribute('data-index', insertIndex + index + 1);
              
              // Create the image wrapper structure similar to media.liquid
              const mediaWrapper = document.createElement('div');
              mediaWrapper.className = 'product-media product-media--image w-full';
              
              const imageContainer = document.createElement('div');
              imageContainer.className = 'relative overflow-hidden';
              imageContainer.style.paddingBottom = '100%';
                
                const img = document.createElement('img');
                img.src = media.src || media;
              img.alt = media.alt || `Variant image ${index + 1}`;
              img.className = 'w-full h-full object-cover absolute top-0 left-0';
                img.loading = 'lazy';
                
              imageContainer.appendChild(img);
              mediaWrapper.appendChild(imageContainer);
              mediaItem.appendChild(mediaWrapper);

              // Insert after the main variant image
              if (container.nextSibling) {
                stackedContainer.insertBefore(mediaItem, container.nextSibling);
              } else {
                stackedContainer.appendChild(mediaItem);
              }
            });
          }

          // Add video if it exists in variant metafields - place in top left corner
          if (this.currentVariant && this.currentVariant.metafields && this.currentVariant.metafields.video_url) {
            const videoUrl = this.currentVariant.metafields.video_url;
            
            const mediaItem = document.createElement('div');
            mediaItem.className = 'product-media-item w-[calc(50%-5px)] postion-image-variant variant-video-item';
            mediaItem.setAttribute('data-variant-image', 'true');
            mediaItem.setAttribute('data-index', '0'); // Set to 0 to appear first
            
            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'product-media product-media--external_video w-full relative';
            videoWrapper.style.paddingBottom = '100%';
            videoWrapper.style.height = '0';
            
            const iframe = document.createElement('iframe');
            iframe.className = 'absolute top-0 left-0 w-full h-full';
            iframe.src = videoUrl;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', '');
            iframe.loading = 'lazy';
            
            videoWrapper.appendChild(iframe);
            mediaItem.appendChild(videoWrapper);

            // Insert at the beginning (top left corner) - prepend to container
            stackedContainer.insertBefore(mediaItem, stackedContainer.firstChild);
          }

          // Hide non-variant product images
          this._hideNonVariantImages();
          // Hide non-variant mobile images
          this._hideNonVariantMobileImages();
        },
        _hideNonVariantImages() {
          const stackedContainer = document.getElementById(`stacked-${sectionId}`);
          if (!stackedContainer) return;

          const variantImages = stackedContainer.querySelectorAll('[data-variant-image="true"]');
          if (variantImages.length > 0) {
            // Hide all product media items that are not variant images
            const allMediaItems = stackedContainer.querySelectorAll('.product-media-item');
            allMediaItems.forEach(item => {
              if (!item.hasAttribute('data-variant-image')) {
                item.style.display = 'none';
          } else {
                item.style.display = 'flex';
              }
            });
          } else {
            // Show all images if no variant images
            const allMediaItems = stackedContainer.querySelectorAll('.product-media-item');
            allMediaItems.forEach(item => {
              item.style.display = '';
            });
          }
        },
        _removeVariantImages() {
          // Remove all variant images from stacked container
          const stackedContainer = document.getElementById(`stacked-${sectionId}`);
          if (stackedContainer) {
            const variantImages = stackedContainer.querySelectorAll('[data-variant-image="true"]');
            variantImages.forEach(el => {
              // Remove the attribute from the main variant image, but keep the element
              if (el.hasAttribute('data-media-id')) {
                el.removeAttribute('data-variant-image');
              } else {
                // Remove dynamically added variant images
                el.remove();
              }
            });
          }
          // Show all images again
          this._hideNonVariantImages();
          // Show all mobile images again
          this._hideNonVariantMobileImages();
        },
        _addExtraMediaToMobileSlider() {
          const mobileSlider = document.getElementById(`x-product-${sectionId}`);
          if (!mobileSlider || !mobileSlider.splide) return;
          
          const thumbnailContainer = document.getElementById(`x-product-thumbnail-${sectionId}`);
          
          // Remove previously added variant media slides
          const existingVariantSlides = mobileSlider.querySelectorAll('.splide__slide.variant-extra-slide');
          existingVariantSlides.forEach(slide => {
            if (mobileSlider.splide) {
              const index = Array.from(mobileSlider.querySelectorAll('.splide__slide')).indexOf(slide);
              if (index > -1) {
                mobileSlider.splide.remove(index);
              }
            }
          });
          
          // Remove previously added thumbnails
          if (thumbnailContainer) {
            const existingVariantThumbs = thumbnailContainer.querySelectorAll('.variant-extra-thumbnail');
            existingVariantThumbs.forEach(thumb => thumb.remove());
          }
          
          let slidesAdded = 0;
          // Insert after first slide (index 1)
          let insertIndex = 1;
          
          // Add extra media files
          if (this.currentVariant?.metafields?.extra_media_files) {
            const extraMedia = this.currentVariant.metafields.extra_media_files;
            
            if (extraMedia && Array.isArray(extraMedia)) {
              extraMedia.forEach((media) => {
                // Add to main slider at specific index
                const slideHtml = `
                  <li class="splide__slide variant-extra-slide">
                    <div class="product-media-item relative">
                      <img src="${media.src}" alt="${media.alt || 'Extra variant image'}" class="w-full h-full object-cover" loading="lazy" />
                    </div>
                  </li>
                `;
                
                if (mobileSlider.splide) {
                  mobileSlider.splide.add(slideHtml, insertIndex);
                  insertIndex++;
                  slidesAdded++;
                }
                
                // Add thumbnail at specific position
                if (thumbnailContainer) {
                  const thumbDiv = document.createElement('div');
                  thumbDiv.className = 'x-thumbnail media-thumbnail variant-extra-thumbnail relative select-none opacity-30 min-w-[50px] md:min-w-[65px] lg:min-w-[85px]';
                  thumbDiv.innerHTML = `
                    <button class="relative block w-full h-full pb-[100%] rounded-[10px] overflow-hidden" aria-label="Extra image thumbnail">
                      <img src="${media.src}" alt="${media.alt || 'Extra variant image'}" loading="lazy" class="w-full object-cover absolute h-full select-none pointer-events-none" />
                    </button>
                  `;
                  const thumbsWrapper = thumbnailContainer.querySelector('div');
                  const firstThumb = thumbsWrapper.children[insertIndex - 1];
                  if (firstThumb && firstThumb.nextSibling) {
                    thumbsWrapper.insertBefore(thumbDiv, firstThumb.nextSibling);
                  } else {
                    thumbsWrapper.appendChild(thumbDiv);
                  }
                }
              });
            }
          }
          
          // Add variant video if it exists in variant metafields
          if (this.currentVariant?.metafields?.video_url) {
            const videoUrl = this.currentVariant.metafields.video_url;
            
            const videoSlideHtml = `
              <li class="splide__slide variant-extra-slide">
                <div class="product-media-item relative w-full" style="aspect-ratio: 1 / 1;">
                  <iframe src="${videoUrl}" class="absolute top-0 left-0 w-full h-full" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>
                </div>
              </li>
            `;
            
            if (mobileSlider.splide) {
              mobileSlider.splide.add(videoSlideHtml, insertIndex);
              insertIndex++;
              slidesAdded++;
            }
            
            // Add video thumbnail
            if (thumbnailContainer) {
              const thumbDiv = document.createElement('div');
              thumbDiv.className = 'x-thumbnail media-thumbnail variant-extra-thumbnail relative select-none opacity-30 min-w-[50px] md:min-w-[65px] lg:min-w-[85px]';
              thumbDiv.innerHTML = `
                <button class="relative block w-full h-full pb-[100%] rounded-[10px] overflow-hidden" aria-label="Variant video thumbnail">
                  <div class="w-full h-full absolute bg-gray-200 flex items-center justify-center">
                    <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20"><path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z"></path></svg>
                  </div>
                </button>
              `;
              const thumbsWrapper = thumbnailContainer.querySelector('div');
              const firstThumb = thumbsWrapper.children[insertIndex - 1];
              if (firstThumb && firstThumb.nextSibling) {
                thumbsWrapper.insertBefore(thumbDiv, firstThumb.nextSibling);
              } else {
                thumbsWrapper.appendChild(thumbDiv);
              }
            }
          }
          
          // Add product video if it exists
          const productVideoScript = document.querySelector(`script[type="application/json"][data-product-video]`);
          if (productVideoScript) {
            const productVideoUrl = JSON.parse(productVideoScript.textContent);
            if (productVideoUrl) {
              const productVideoSlideHtml = `
                <li class="splide__slide variant-extra-slide">
                  <div class="product-media-item relative w-full" style="aspect-ratio: 1 / 1;">
                    <iframe src="${productVideoUrl}" class="absolute top-0 left-0 w-full h-full" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>
                  </div>
                </li>
              `;
              
              if (mobileSlider.splide) {
                mobileSlider.splide.add(productVideoSlideHtml, insertIndex);
                insertIndex++;
                slidesAdded++;
              }
              
              // Add product video thumbnail
              if (thumbnailContainer) {
                const thumbDiv = document.createElement('div');
                thumbDiv.className = 'x-thumbnail media-thumbnail variant-extra-thumbnail relative select-none opacity-30 min-w-[50px] md:min-w-[65px] lg:min-w-[85px]';
                thumbDiv.innerHTML = `
                  <button class="relative block w-full h-full pb-[100%] rounded-[10px] overflow-hidden" aria-label="Product video thumbnail">
                    <div class="w-full h-full absolute bg-gray-200 flex items-center justify-center">
                      <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20"><path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z"></path></svg>
                    </div>
                  </button>
                `;
                const thumbsWrapper = thumbnailContainer.querySelector('div');
                const firstThumb = thumbsWrapper.children[insertIndex - 1];
                if (firstThumb && firstThumb.nextSibling) {
                  thumbsWrapper.insertBefore(thumbDiv, firstThumb.nextSibling);
                } else {
                  thumbsWrapper.appendChild(thumbDiv);
                }
              }
            }
          }
          
          // Refresh the slider if slides were added
          if (slidesAdded > 0 && mobileSlider.splide) {
            mobileSlider.splide.refresh();
          }
          
          // Hide non-variant images in mobile slider - call immediately and after refresh
          requestAnimationFrame(() => {
            this._hideNonVariantMobileImages();
          });
        },
        _hideNonVariantMobileImages() {
          const mobileSlider = document.getElementById(`x-product-${sectionId}`);
          const thumbnailContainer = document.getElementById(`x-product-thumbnail-${sectionId}`);
          
          if (!mobileSlider) return;
          
          // Add CSS rule to ensure hidden slides stay hidden
          const styleId = `variant-hide-non-variant-${sectionId}`;
          if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
              #x-product-${sectionId} .splide__slide.non-variant-slide {
                display: none !important;
                visibility: hidden !important;
                opacity: 0 !important;
                width: 0 !important;
                margin: 0 !important;
                transform: none !important;
                pointer-events: none !important;
                position: absolute !important;
                left: -9999px !important;
              }
            `;
            document.head.appendChild(style);
          }
          
          // Check if we have a variant with featured media and extra media files
          const hasVariant = this.currentVariant && this.currentVariant.featured_media;
          const hasExtraMedia = hasVariant && this.currentVariant.metafields?.extra_media_files?.length > 0;
          
          // Hide non-variant images if we have variant images (featured + extra media)
          if (hasVariant && hasExtraMedia && this.currentVariant.featured_media.id) {
            const variantMediaId = this.currentVariant.featured_media.id;
            // The data-media-id format is: sectionId-variantMediaId (e.g., "template--20786765070589__main-35983390179581")
            const variantMediaIdString = `${sectionId}-${variantMediaId}`;
            
            // Get all slides - check both in splide__list and directly
            const splideList = mobileSlider.querySelector('.splide__list');
            const allSlides = splideList ? splideList.querySelectorAll('.splide__slide') : mobileSlider.querySelectorAll('.splide__slide');
            
            // Store indices of slides to remove (in reverse order to avoid index shifting)
            const slidesToHide = [];
            
            allSlides.forEach((slide, index) => {
              // Check if this is a variant extra slide (dynamically added)
              const isVariantExtraSlide = slide.classList.contains('variant-extra-slide');
              
              // Check if this is the main variant slide by data-media-id attribute (directly on slide)
              const slideMediaId = slide.getAttribute('data-media-id');
              // Match exact or check if it ends with the variant media ID
              const isVariantMainSlide = slideMediaId === variantMediaIdString || 
                                        (slideMediaId && slideMediaId.endsWith(`-${variantMediaId}`));
              
              // Also check child elements for data-media-id
              const childWithMediaId = slide.querySelector('[data-media-id]');
              const childMediaId = childWithMediaId ? childWithMediaId.getAttribute('data-media-id') : null;
              const isVariantByChild = childMediaId === variantMediaIdString || 
                                      (childMediaId && childMediaId.endsWith(`-${variantMediaId}`));
              
              // Also check by class name pattern (e.g., "35983390179581-template--20786765070589__main")
              // Note: Class names starting with numbers need to be escaped in CSS selectors
              // Use classList.contains instead of querySelector for numeric class names
              const variantClassName = `${variantMediaId}-${sectionId}`;
              const hasVariantClass = slide.classList.contains(variantClassName) ||
                                     Array.from(slide.classList).some(cls => cls === variantClassName || cls.includes(variantMediaId));
              
              if (isVariantExtraSlide || isVariantMainSlide || isVariantByChild || hasVariantClass) {
                slide.style.display = '';
                slide.style.visibility = 'visible';
                slide.style.opacity = '';
                slide.style.position = '';
                slide.style.left = '';
                slide.classList.add('variant-slide-visible');
                slide.classList.remove('non-variant-slide');
              } else {
                // Mark for hiding
                slidesToHide.push({ slide, index });
              }
            });
            
            // Move non-variant slides to hidden container (store them for later restoration)
            if (!mobileSlider._hiddenNonVariantSlides) {
              mobileSlider._hiddenNonVariantSlides = [];
            }
            
            // Create hidden container if it doesn't exist
            let hiddenContainer = document.getElementById(`hidden-non-variant-slides-${sectionId}`);
            if (!hiddenContainer) {
              hiddenContainer = document.createElement('div');
              hiddenContainer.id = `hidden-non-variant-slides-${sectionId}`;
              hiddenContainer.style.display = 'none';
              hiddenContainer.style.visibility = 'hidden';
              hiddenContainer.style.position = 'absolute';
              hiddenContainer.style.left = '-9999px';
              document.body.appendChild(hiddenContainer);
            }
            
            slidesToHide.forEach(({ slide }) => {
              slide.classList.add('non-variant-slide');
              slide.classList.remove('variant-slide-visible', 'is-active', 'is-visible');
              
              // Store slide data before moving
              if (!mobileSlider._hiddenNonVariantSlides.find(s => s.element === slide)) {
                mobileSlider._hiddenNonVariantSlides.push({
                  element: slide,
                  originalParent: slide.parentNode,
                  nextSibling: slide.nextSibling
                });
              }
              
              // Move to hidden container
              if (slide.parentNode !== hiddenContainer) {
                hiddenContainer.appendChild(slide);
              }
            });
            
            // Hide non-variant thumbnails
            if (thumbnailContainer) {
              const allThumbs = thumbnailContainer.querySelectorAll('.x-thumbnail');
              allThumbs.forEach(thumb => {
                const thumbMediaId = thumb.getAttribute('data-media-id');
                const isVariantThumb = thumbMediaId === variantMediaIdString || 
                                      (thumbMediaId && thumbMediaId.endsWith(`-${variantMediaId}`));
                const isVariantExtraThumb = thumb.classList.contains('variant-extra-thumbnail');
                
                if (isVariantThumb || isVariantExtraThumb) {
                  thumb.style.display = '';
                  thumb.style.visibility = 'visible';
                } else {
                  thumb.style.setProperty('display', 'none', 'important');
                  thumb.style.setProperty('visibility', 'hidden', 'important');
                }
              });
            }
            
            // Refresh slider after removing slides
            if (mobileSlider.splide) {
              mobileSlider.splide.refresh();
            }
          } else {
            // Restore hidden slides if they were moved
            if (mobileSlider._hiddenNonVariantSlides && mobileSlider._hiddenNonVariantSlides.length > 0) {
              const splideList = mobileSlider.querySelector('.splide__list');
              if (splideList) {
                mobileSlider._hiddenNonVariantSlides.forEach(({ element, originalParent, nextSibling }) => {
                  // Restore to original position
                  if (element.parentNode && element.parentNode.id === `hidden-non-variant-slides-${sectionId}`) {
                    if (nextSibling && nextSibling.parentNode === originalParent) {
                      originalParent.insertBefore(element, nextSibling);
                    } else if (originalParent) {
                      originalParent.appendChild(element);
                    }
                  }
                });
                mobileSlider._hiddenNonVariantSlides = [];
              }
            }
            
            // Remove hidden container if empty
            const hiddenContainer = document.getElementById(`hidden-non-variant-slides-${sectionId}`);
            if (hiddenContainer && hiddenContainer.children.length === 0) {
              hiddenContainer.remove();
            }
            
            // Show all slides if no variant images to hide
            const splideList = mobileSlider.querySelector('.splide__list');
            const allSlides = splideList ? splideList.querySelectorAll('.splide__slide') : mobileSlider.querySelectorAll('.splide__slide');
            allSlides.forEach(slide => {
              slide.style.removeProperty('display');
              slide.style.removeProperty('visibility');
              slide.style.removeProperty('opacity');
              slide.style.removeProperty('transform');
              slide.style.removeProperty('width');
              slide.style.removeProperty('margin');
              slide.style.removeProperty('position');
              slide.style.removeProperty('left');
              slide.classList.remove('variant-slide-visible', 'non-variant-slide');
            });
            
            // Show all thumbnails
            if (thumbnailContainer) {
              const allThumbs = thumbnailContainer.querySelectorAll('.x-thumbnail');
              allThumbs.forEach(thumb => {
                thumb.style.removeProperty('display');
                thumb.style.removeProperty('visibility');
              });
            }
            
            // Refresh slider after restoring slides
            if (mobileSlider.splide) {
              mobileSlider.splide.refresh();
            }
          }
        },
        _validateOption() {
          const mediaWithOption = document.querySelector(`#shopify-section-${sectionId} [data-media-option]`);
          if (mediaWithOption)
            this.mediaOption = mediaWithOption.dataset.mediaOption.split('_');
        },
        updateMultiMediaWithVariant() {
          this._validateOption();
          if (!this.currentVariant) {
            if (this.initfirstMedia) {
              let productMedia = document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-option], #shopify-section-${ sectionId } [data-media-option]`);
              Array.from(productMedia).reverse().forEach(function(newMedia, position) {
                newMedia.classList.add('media_active');
                if (newMedia.classList.contains('media-slide')) {
                  newMedia.classList.add('splide__slide');
                }
              });
            }
            return;
          }
          const variantInputs = this.mediaOption.map(option =>
            document.querySelector(`#shopify-section-${sectionId} [data-option-name="${option}"]`)
          ).filter(el => el !== null);
          if (variantInputs.length === 0) {
            let variantMedias = ""
            if (!this.currentVariant?.featured_media?.id) {
              variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option].featured-image, #shopify-section-${ sectionId } [data-media-option].featured-image`); 
            } else {
              variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option="${sectionId}-${this.currentVariant?.featured_media?.id}"], #shopify-section-${ sectionId } [data-media-option="${sectionId}-${this.currentVariant?.featured_media?.id}"]`);
            }
            let mediaActive = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option=""], #shopify-section-${ sectionId } [data-media-option=""]`);
            let productMedias = document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-option], #shopify-section-${ sectionId } [data-media-option]`);
            const newMedias = Array.prototype.concat.call( ...mediaActive, ...variantMedias)
            this._setActiveMedia(productMedias, newMedias, variantMedias);

            let splideEl = document.getElementById(`x-product-${ sectionId }`);
            if (splideEl.splide) {
              splideEl.splide.refresh();
              splideEl.splide.go(0);
            }
            let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
            if (splideZoomEl.splide) {
              splideZoomEl.splide.refresh();
            }
          } else {
            let optionConnects = [];
            variantInputs.forEach((variantInput) => {
              const variantOptionIndex = variantInput && variantInput.dataset.optionIndex;
              const optionValue = this._handleText(this.currentVariant?.options[variantOptionIndex]);
              if (this.mediaOption.includes(variantInput.dataset.optionName)) {
                optionConnects.push(variantInput.dataset.optionName + '-' + optionValue);
              }
              this.optionIndex = variantOptionIndex;
            });
            const mediaActive = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type=""], #shopify-section-${ sectionId } [data-media-type=""]`);
            
            let variantMedias = [];
            let allVariantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type]:not([data-media-type=""]), #shopify-section-${ sectionId } [data-media-type]:not([data-media-type=""])`);
            allVariantMedias.forEach((variantMedia) => {
              let data = variantMedia.getAttribute('data-media-type');
              let dataSet = new Set(data.split('_'));
              if (optionConnects.filter(option => dataSet.has(option)).length === dataSet.size) variantMedias.push(variantMedia);
            });

            let showFeatured = false;
            if (!variantMedias.length) {
              if (!this.currentVariant?.featured_media?.id) {
                variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option].featured-image, #shopify-section-${ sectionId } [data-media-option].featured-image`); 
                showFeatured = true;
              } else {
                variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-id="${sectionId}-${this.currentVariant?.featured_media?.id}"], #shopify-section-${ sectionId } [data-media-id="${sectionId}-${this.currentVariant?.featured_media?.id}"]`);
              }
            }
            if (!variantMedias.length) {
              document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-type], #shopify-section-${ sectionId } [data-media-type]`).forEach(function(media){
                media.classList.add('media_active');
                media.classList.add('splide__slide');
              });
              let splideEl = document.getElementById(`x-product-${ sectionId }`);
              if (splideEl.splide) {
                splideEl.splide.refresh();
                splideEl.splide.go(0);
              }
              let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
              if (splideZoomEl.splide) {
                splideZoomEl.splide.refresh();
              }
              return;
            }
            
            const newMedias = Array.prototype.concat.call(...variantMedias , ...mediaActive);
            let productMedias = document.querySelectorAll( `#shopify-section-${ sectionId } [data-media-type], #ProductModal-${ sectionId } [data-media-type]`);
            
            this._setActiveMedia(productMedias, newMedias);
            
            if (this.optionConnect != optionConnects) {
              this.optionConnect = optionConnects;
            }
            
            let splideEl = document.getElementById(`x-product-${ sectionId }`);
            if (splideEl.splide) {
              splideEl.splide.refresh();
              splideEl.splide.go(0);
            }
            let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
            if(splideZoomEl && splideZoomEl.splide){
              splideZoomEl.splide.refresh();
            }
            
            if (showFeatured) {
              this._goToFirstSlide();
            }  
          }
        },
        _setActiveMedia(productMedias, newMedias, activeMedia) {
          productMedias.forEach(function(media){
            media.classList.remove('media_active');
            media.classList.remove('splide__slide');
            media.classList.remove('x-thumbnail');
          });
          Array.from(newMedias).reverse().forEach(function(newMedia, position) {
            newMedia.classList.add('media_active');
            if (newMedia.classList.contains('media-thumbnail')) {
              newMedia.classList.add('x-thumbnail');
            }
            if (newMedia.classList.contains('media-slide')) {
              newMedia.classList.add('splide__slide');
            }
            let parent = newMedia.parentElement;
            if (activeMedia) {
              if (parent.firstChild != newMedia && Array.from(activeMedia).includes(newMedia)) {
                parent.prepend(newMedia);
              }
            } else {
              if (parent.firstChild != newMedia) {
                parent.prepend(newMedia);
              }
            }
          });

          if (activeMedia) {
            let parent = activeMedia.parentElement;
            parent && parent.prepend(activeMedia);
          }
        },
        _handleText(someString) {
          if (someString) {
            return someString.toString().replace('ı', 'i').replace('ß', 'ss').normalize('NFC').replace('-', ' ').toLowerCase().trim().replace(/[^\p{L}\p{N}\s-]/gu, '').replace(/\s+/g, "-");
          }
        },
        _goToFirstSlide() {
          if (this.currentVariant && !this.currentVariant.featured_image) {
            let splideEl = document.getElementById("x-product-" + sectionId);
            if (splideEl) {
              if (splideEl.splide && this.currentVariant && this.currentVariant.featured_image != null) {
                splideEl.splide.go(0);
              }
            }

            let activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
            let stackedEL = document.getElementById('stacked-' + sectionId);
            if(stackedEL && activeEL) stackedEL.prepend(activeEL);
          }
        },
        _updateProductForms() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
              input.value = this.currentVariant?.id;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        },
        _renderPriceProduct(html) {
          const destination = document.getElementById('price-' + sectionId);
          let source = html.getElementById('price-' + sectionId);
          if (!this.currentVariant) {
            destination.classList.add('hidden');
            return;
          } else {
            destination.classList.remove('hidden');
          }
          if(!source) {
            source = html.querySelector('.price');
            if (source && destination) destination.innerHTML = source.outerHTML;
          } else {
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _renderBuyButtons(html) {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          
          productForms.forEach((productForm) => {
            const atcSource = html.querySelector(`#${productForm.getAttribute("id")} .add_to_cart_button`);
            const atcDestination = productForm.querySelector('.add_to_cart_button');
            if (!atcDestination) return;

            if (atcSource && atcDestination) atcDestination.innerHTML = atcSource.innerHTML;
    
            if (this.currentVariant?.available) {
              /// Enable add to cart button
              atcDestination.dataset.available = "true";
              if (html.getElementById('form-gift-card-' + sectionId)) {
                if (document.getElementById('Recipient-checkbox-' + sectionId).checked && document.getElementById('recipient-form-' + sectionId).dataset.disabled == "true") {
                  atcDestination.setAttribute('disabled', 'disabled') 
                } else {
                  atcDestination.removeAttribute('disabled');
                }
              } else {
                atcDestination.removeAttribute('disabled');
              }
            } else {
              atcDestination.dataset.available = "false";
              atcDestination.setAttribute('disabled', 'disabled');
            }

            const cloneProductForms = document.querySelectorAll(`#product-form-${cloneSectionId}, #product-form-installment-${cloneSectionId}, #product-form-sticky-${cloneSectionId}`);
            cloneProductForms.forEach((cloneProductForm) => {
              if (cloneProductForm.getAttribute("id").includes(productForm.getAttribute("id"))){
                const atcCloneDestination = cloneProductForm.querySelector('.add_to_cart_button');
                if (!atcCloneDestination) return;

                if (atcSource && atcCloneDestination) atcCloneDestination.innerHTML = atcSource.innerHTML;
        
                if (this.currentVariant?.available) {
                  /// Enable add to cart button
                  atcCloneDestination.dataset.available = "true";
                  if (html.getElementById('form-gift-card-' + sectionId)) {
                    if (document.getElementById('Recipient-checkbox-' + sectionId).checked && document.getElementById('recipient-form-' + sectionId).dataset.disabled == "true") {
                      atcCloneDestination.setAttribute('disabled', 'disabled') 
                    } else {
                      atcCloneDestination.removeAttribute('disabled');
                    }
                  } else {
                    atcCloneDestination.removeAttribute('disabled');
                  }
                } else {
                  atcCloneDestination.dataset.available = "false";
                  atcCloneDestination.setAttribute('disabled', 'disabled');
                }
              }
            })

          });
          const paymentButtonDestination = document.getElementById('x-payment-button-' + sectionId);
          const paymentButtonSource = html.getElementById('x-payment-button-' + sectionId);
          if (paymentButtonSource && paymentButtonDestination) {
            if (paymentButtonSource.classList.contains('hidden')) {
              paymentButtonDestination.classList.add('hidden');
            } else {
              paymentButtonDestination.classList.remove('hidden');
            }
          }
        },
        _setMessagePreOrder(html) {
          const msg = document.querySelector(`.pre-order-${sectionId}`);
          if (!msg) return;
          msg.classList.add('hidden');
          const msg_pre = html.getElementById(`pre-order-${sectionId}`);
          if (msg_pre) {
            msg.classList.remove('hidden');
            msg.innerHTML = msg_pre.innerHTML;
          }
        },
        _setEstimateDelivery(html) {
          const est = document.getElementById(`x-estimate-delivery-container-${sectionId}`);
          if (!est) return;
          const est_res = html.getElementById(`x-estimate-delivery-container-${sectionId}`);
          if (est_res.classList.contains('disable-estimate')) {
            est.classList.add('hidden');
          } else {
            est.classList.remove('hidden');
            est.innerHTML = est_res.innerHTML;
          }

          const estimateDeliveryCart = document.querySelectorAll(`.cart-edt-${sectionId}`);
          const estimateDeliveryCartUpdate = html.querySelectorAll(`.cart-edt-${sectionId}`);
          if (estimateDeliveryCart.length > 0 && estimateDeliveryCartUpdate.length > 0) {
            estimateDeliveryCart.forEach((item, index) => {
              if(estimateDeliveryCartUpdate[index] != undefined && estimateDeliveryCartUpdate[index].innerHTML != undefined ){
                item.innerHTML = estimateDeliveryCartUpdate[index].innerHTML;
              }
            })
          }
        },
        _setMetafieldInfo(html, query) {
          const content_arr = document.querySelectorAll(`${query}-${sectionId}`);
          const content_res_arr = html.querySelectorAll(`${query}-${sectionId}`);       
          if (content_arr.length > 0 && content_res_arr.length > 0) {
            content_arr.forEach((toc, index) => {
              toc.innerHTML = content_res_arr[index].innerHTML;
            })
          }
        },
        _setBackInStockAlert(html) {
          const destination = document.getElementById(`back_in_stock_alert-${sectionId}`);
          const source = html.getElementById(`back_in_stock_alert-${sectionId}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _setPickupPreOrder(html) {
          const pickup = document.getElementById(`pickup-pre-order-${sectionId}`);
          if (!pickup) return;
          const pickup_res = html.getElementById(`pickup-pre-order-${sectionId}`);
          if (pickup_res.classList.contains('disable-pickup')) {
            pickup.classList.add('hidden');
          } else {
            pickup.classList.remove('hidden');
          }
        },
        _setUnavailable() {
          const selectors = ['price-sticky-', 'block-inventory-', 'x-badges-', 'pickup-', 'sku-', 'back_in_stock_alert-'];
          for (let selector of selectors) {
            const element = document.getElementById(selector + sectionId);
            if (element) element.classList.add('hidden');
          }
          
          const msg_pre = document.querySelector(`.pre-order-${sectionId}`);
          if (msg_pre) msg_pre.classList.add('hidden');
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.add('unavailable');

          this._setBuyButtonUnavailable();
        },
        _setAvailable() {
          const selectors = ['block-inventory-', 'x-badges-', 'pickup-', 'sku-', 'back_in_stock_alert-'];
          for (let selector of selectors) {
            const element = document.getElementById(selector + sectionId);
            if (element) element.classList.remove('hidden');
          }
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.remove('unavailable');
        },
        _setBuyButtonUnavailable() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId},  #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const addButton = productForm.querySelector('.add_to_cart_button');
            if (!addButton) return;
            addButton.setAttribute('disabled', 'disabled');
            const addButtonText = addButton.querySelector('.x-atc-text');
            if (addButtonText) addButtonText.textContent = unavailableText;
          });
        },
        initEventSticky() {
          document.addEventListener(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, (e) => {
            this.handleSticky = e.detail.variantElSticky;
            this.updateVariantSelector(-1, e.detail.targetUrl);
          });
        },
        _getCurrentVariant(html) {
          const variantScript = html.querySelector(`script[type="application/json"][data-selected-variant]`);
          if (!variantScript || !variantScript.textContent) {
            console.warn('Variant script not found in HTML');
            return;
          }
          
          this.currentVariant = JSON.parse(variantScript.textContent);
          
          // Load metafields data
          const metafieldsScript = html.querySelector(`script[type="application/json"][data-variant-metafields]`);
          if (metafieldsScript) {
            const allVariantMetafields = JSON.parse(metafieldsScript.textContent);
            if (allVariantMetafields[this.currentVariant.id]) {
              this.currentVariant.metafields = allVariantMetafields[this.currentVariant.id];
            }
          }
        },
        updateVariantSelector(inputId, target) {
          let updateFullpage = false;
          let callback = () => {};
          
          const targetUrl = target || element.dataset.url;
          if (element.dataset.url !== targetUrl) {
            if (isProductPage) {
              updateFullpage = true;
            }
            callback = (html) => {
              this._getCurrentVariant(html);
              this._setAvailable();
              this._updateURL(targetUrl);
              this._handleSwapProduct(sectionId, html, updateFullpage);
              this._handleSwapQuickAdd(html);
              this._renderCardBundle(html);
              this._renderCardFBT(html);
              this._dispatchUpdateVariant(html);
              this._dispatchVariantSelected(html);
            };
          } else {
            callback = (html) => {
              this._getCurrentVariant(html);
              this._setAvailable();
              this._updateURL(targetUrl);
              this._updateProductForms();
              this._handleUpdateProductInfo(html);
              this._updateOptionValues(html);
              this._updateMedia(html);
              this._handleAvailable(html);
              this._dispatchUpdateVariant(html);
              this._dispatchVariantSelected(html);
            }
          }
          this._renderProductInfo(targetUrl, callback, updateFullpage);
        },
        _renderProductInfo(url, callback, updateFullpage) {
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues();
          let params = `option_values=${selectedOptionValues.join(',')}`;
          link = updateFullpage?`${url}?${params}`:`${url}?section_id=${this.handleSectionId}&${params}`;
          Alpine.store('xHelper').cancelRequest('eurus:product_info_request');
          if (this.cachedResults[link]) {
            const html = this.cachedResults[link];
            callback(html);
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:product_info_request', controller);
            fetch(link, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                callback(html);
                this.cachedResults[link] = html;
              }).catch(err => {
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
              })
          }
          this.handleSticky = '';
        },
        _handleUpdateProductInfo(html) {
          this._renderCardBundle(html);
          this._renderCardFBT(html);
          this._renderPriceProduct(html);
          const selectors = ['block-inventory-', 'block-available-quantity-', 'quantity-selector-', 'volume-', 'sku-', 'x-badges-', 'preorder-', 'cart-edt-'];
          for (let selector of selectors) {
            this._renderDestination(html, selector);
          }
          this._renderBuyButtons(html);
          this._setMessagePreOrder(html);
          this._setEstimateDelivery(html);
          
          const mtfSelectors = ['.properties_re_render', '.table_info_details', '.block-text', '.text-icon', '.collapsible-content', '.nutrition-bar-content', '.horizontab', '.featured-icon'];
          for (let selector of mtfSelectors) {
            this._setMetafieldInfo(html, selector);
          }
          this._setPickupPreOrder(html);
          this._setBackInStockAlert(html);
          Alpine.store('xUpdateVariantQuanity').render(html, this.handleSectionId);
          this._dispatchUpdateVariant(html);
          this._dispatchVariantSelected(html);
          this._updateOptionValues(html);
          document.dispatchEvent(new Event('updateMainPrice'));
          Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant?.id);
        },
        initFirstAvailableVariant(el) {
          this.currentVariant = JSON.parse(el.querySelector(`script[type="application/json"][data-selected-variant]`).textContent);
          
          // Load metafields for the first variant
          const metafieldsScript = el.querySelector(`script[type="application/json"][data-variant-metafields]`);
          if (metafieldsScript) {
            const allVariantMetafields = JSON.parse(metafieldsScript.textContent);
            if (allVariantMetafields[this.currentVariant.id]) {
              this.currentVariant.metafields = allVariantMetafields[this.currentVariant.id];
            }
          }
          
          // Spread variant images for the first variant if one is selected
          if (this.currentVariant && this.currentVariant.featured_media) {
            requestAnimationFrame(() => {
              const variantImageEl = document.getElementById(`postion-image-${sectionId}-${this.currentVariant.featured_media.id}`);
              if (variantImageEl) {
                this._spreadVariantImages(variantImageEl);
              } else {
                // If no variant image element found, ensure all images are shown
                this._hideNonVariantImages();
                this._hideNonVariantMobileImages();
              }
            });
            
            // Wait for mobile slider to be ready before adding extra media
            document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
              this._addExtraMediaToMobileSlider();
              // Also hide non-variant images after slider is ready
              setTimeout(() => {
                this._hideNonVariantMobileImages();
              }, 200);
            }, { once: true });
          } else {
            // No variant selected, show all images
            requestAnimationFrame(() => {
              this._hideNonVariantImages();
              this._hideNonVariantMobileImages();
            });
          }
          
          document.addEventListener('eurus:cart:items-changed', () => {
            this.cachedResults = [];
            Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant?.id);
          });
        },
        _handleAvailable(html) {
          const selectedVariant = html.querySelector('.variant-selects [data-selected-variant]')?.innerHTML;
          if (selectedVariant == 'null') {
            this._setUnavailable();
          }
        },
        _updateOptionValues(html) {
          const variantSelects = html.querySelector('.variant-selects');
          if (variantSelects) {
            element.innerHTML = variantSelects.innerHTML;
            Alpine.initTree(element);
            Array.from(element.querySelectorAll('input')).forEach(input => {
              if (input.dataset.valueSelected === 'true') input.checked = true;
            });
          }
        },
        _getVariantData(inputId) {
          return JSON.parse(this._getVariantDataElement(inputId).textContent);
        },
        _getVariantDataElement(inputId) {
          return element.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
        },
        _updateURL(url) {
          if (!isProductPage) return;
          window.history.replaceState({}, '', `${url}${this.currentVariant?.id ? `?variant=${this.currentVariant?.id}` : ''}`);
        },
        _getSelectedOptionValues() {
          if (this.handleSticky == '') {
            return Array.from(element.querySelectorAll('select option[selected], fieldset input:checked')).map(
              (e) => e.dataset.optionValueId
            );
          } else {
            return Array.from(this.handleSticky.querySelectorAll('select option[selected]')).map(
              (e) => e.dataset.optionValueId
            );
          }
        },
        _renderCardBundle(html) {
          const destination = element.closest(".x-product-bundle-data");
          const card = html.getElementById('card-product-bundle-'+ this.handleSectionId);
          if (card) {
            const source = card.querySelector(".x-product-bundle-data");
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _renderCardFBT(html) {
          const destination = element.closest(".card-product-fbt");
          const source = html.querySelector('.card-product-fbt-clone .card-product-fbt');
          
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _handleSwapProduct(sectionId, html, updateFullpage) {
          if (updateFullpage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            const destination = document.querySelector('main');
            const source = html.querySelector('main');
            if (source && destination) destination.innerHTML = source.innerHTML;
          } else {
            const destination = document.querySelector('.x-product-' + sectionId);
            const source = html.querySelector('.x-product-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _handleSwapQuickAdd(html) {
          const destination = element.closest(".choose-options-content");
          const source = html.querySelector('.choose-options-content');
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      }))
    });
  });

  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xPickupAvailable', {
        cachedResults: [],
        updatePickUp(id, variantId) {
          const container = document.getElementsByClassName('pick-up-'+ id)[0];
          if (!container) return;

          const link = window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`;
          Alpine.store('xHelper').cancelRequest('eurus:pickup_availability_request');
          if (this.cachedResults[link]) {
            container.innerHTML = this.cachedResults[link].innerHTML;
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:pickup_availability_request', controller);
            fetch(link, { signal: controller.signal })
            .then(response => response.text())
            .then(text => {
              const pickupAvailabilityHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');  
              this.cachedResults[link] = pickupAvailabilityHTML;
              container.innerHTML = pickupAvailabilityHTML.innerHTML;
            })
            .catch(e => {
              console.error(e);
            }); 
          }
        }
      });
    });
  });
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xUpdateVariantQuanity', {
        cachedResults: [],
        updateQuantity(sectionId, productUrl, currentVariant) {
          const quantity = document.getElementById('x-quantity-' + sectionId);
          const pricingPB = document.getElementById('x-pricing-progress-bar-' + sectionId);
          if (!quantity && !pricingPB) return;
          const url = currentVariant ? `${productUrl}?variant=${currentVariant}&section_id=${sectionId}` : `${productUrl}?section_id=${sectionId}`;
          Alpine.store('xHelper').cancelRequest('eurus:variant_quantity_request');
          if (this.cachedResults[url]) {
            this.render(this.cachedResults[url], sectionId);
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set('eurus:variant_quantity_request', controller);
            fetch(url, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                let html = new DOMParser().parseFromString(responseText, 'text/html');
                this.cachedResults[url] = html;
                this.render(html, sectionId);
              });
          }
        },
        render(html, sectionId) {
          const destination = document.getElementById('x-quantity-' + sectionId);
          const source = html.getElementById('x-quantity-'+ sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;

          const destinationPricingPB = document.getElementById('x-pricing-progress-bar-' + sectionId);
          const sourcePricingPB = html.getElementById('x-pricing-progress-bar-' + sectionId);
          if (sourcePricingPB && destinationPricingPB) destinationPricingPB.innerHTML = sourcePricingPB.innerHTML;     
        }
      });
    });
  });
}

(function () {
  function safeNumber(val) {
    if (val == null) return 0;
    var str = String(val).replace(/[^0-9.\-]/g, '').trim();
    var num = parseFloat(str);
    return isNaN(num) ? 0 : num;
  }

  function setInputValue(selector, value) {
    $(selector).each(function () {
      $(this).val(value);
      $(this).attr('value', value);
    });
  }

  function triggerMainPriceUpdate() {
    document.dispatchEvent(new Event('updateMainPrice'));
  }

  document.addEventListener('updateMainPrice', function () {
    if($('body').hasClass('template__product')){

    }else{
      return;
    }
    var selectedval = $('input[name="gold-purity"]:checked').val() || '';
    var mainprice = safeNumber($('.target-price').html());
    var maincompprice = safeNumber($('.target-compare-at-price').html());
    console.log(selectedval + ' fff');

    if ($('.purity-options').length > 0) {
      setInputValue('input[name="properties[Gold Purity]"]', selectedval);

      if (selectedval === '14K') {
        mainprice = mainprice + (Shopify.currency.rate * 10000);
        maincompprice = maincompprice + (Shopify.currency.rate * 20000);
      }

      if (selectedval === '18K') {
        mainprice = mainprice + (Shopify.currency.rate * 20000);
        maincompprice = maincompprice + (Shopify.currency.rate * 40000);
      }
    }

    if ($('.bandwidth-percentage__radio').length > 0) {
      var selectedBandwidth = $('.bandwidth-percentage__radio:checked');
      var bandwidthPercentage = 0;

      if (selectedBandwidth.length > 0) {
        bandwidthPercentage = Number(selectedBandwidth.attr('data-percentage')) || 0;

        if (bandwidthPercentage > 0) {
          mainprice = mainprice + ((mainprice * bandwidthPercentage) / 100);
          maincompprice = maincompprice + ((maincompprice * bandwidthPercentage) / 100);
        }

        setInputValue('input[name="properties[Bandwidth]"]', selectedBandwidth.attr('data-bandwidth') || '');

        if ($('input[name="properties[_Bandwidth_Increase]"]').length > 0) {
          setInputValue('input[name="properties[_Bandwidth_Increase]"]', bandwidthPercentage);
        }

        if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
          setInputValue('input[name="properties[_Bandwidth_Percentage]"]', bandwidthPercentage);
        }
      }
    }

    if ($('.custom-v1-option-radio').length > 0) {
      $('.custom-v1-option-fieldset').each(function () {
        var $fieldset = $(this);
        var optionHandle = $fieldset.attr('data-option-handle');
        var $selected = $fieldset.find('.custom-v1-option-radio:checked');

        if ($selected.length > 0) {
          var optionLabel = $selected.attr('data-option-label') || '';
          var optionPrice = Number($selected.attr('data-price')) || 0;
          var optioncomPrice = Number($selected.attr('data-compprice')) || 0;
          var convertedOptionPrice = (optionPrice * 100) * Shopify.currency.rate;
          var convertedOptionCompPrice = (optioncomPrice * 100) * Shopify.currency.rate;

          if (convertedOptionPrice > 0) {
            mainprice = mainprice + convertedOptionPrice; 
          }
          if (convertedOptionCompPrice > 0) { 
            maincompprice = maincompprice + convertedOptionCompPrice;
          }else{
            if (convertedOptionPrice > 0) { 
              maincompprice = maincompprice + convertedOptionPrice;
            }
          }

          $('[data-custom-option-property="' + optionHandle + '"]').each(function () {
            $(this).val(optionLabel).attr('value', optionLabel);
          });

          $('[data-custom-option-price-property="' + optionHandle + '"]').each(function () {
            $(this).val(optionPrice * 100).attr('value', optionPrice * 100);
          });
        }
      });
    }

    if ($('[data-nested-v1-wrapper]').length > 0) {
      function getNestedJsonData() {
        var wrapper = document.querySelector('[data-nested-v1-wrapper]');
        if (!wrapper) return null;

        var jsonEl = wrapper.querySelector('[data-nested-variant-json]');
        if (!jsonEl) return null;

        try {
          return JSON.parse(jsonEl.textContent);
        } catch (e) {
          return null;
        }
      }

      function getByOptionName(arr, name) {
        if (!Array.isArray(arr)) return null;
        name = String(name || '').trim().toLowerCase();

        return arr.find(function (item) {
          return String(item.option_name || '').trim().toLowerCase() === name;
        }) || null;
      }

      function getOptions(group) {
        if (!group) return [];
        if (Array.isArray(group.Options)) return group.Options;
        if (Array.isArray(group.options)) return group.options;
        return [];
      }

      function getSelectedRadioValue(prefix) {
        var el = document.querySelector('input[name^="' + prefix + '_"]:checked');
        return el ? String(el.value || '').trim() : '';
      }

      var nestedData = getNestedJsonData();

      var selectedWeightValue = getSelectedRadioValue('nested_diamond_weight');
      var selectedColorValue = getSelectedRadioValue('nested_diamond_color');
      var selectedClarityValue = getSelectedRadioValue('nested_diamond_clarity');
      var selectedGoldPurityValue = getSelectedRadioValue('nested_gold_purity');

      var nestedWeightPrice = 0;
      var nestedWeightComparePrice = 0;
      var nestedColorPrice = 0;
      var nestedColorComparePrice = 0;
      var nestedClarityPrice = 0;
      var nestedClarityComparePrice = 0;
      var nestedGoldPurityPrice = 0;
      var nestedGoldPurityComparePrice = 0;

      if (nestedData && Array.isArray(nestedData.variant_data)) {
        // "Diamond Weight", or "Gemstone Weight" on gemstone pieces (set by custom-variant-options.liquid)
        var nestedWrapperEl = document.querySelector('[data-nested-v1-wrapper]');
        var weightGroupName = (nestedWrapperEl && nestedWrapperEl.getAttribute('data-weight-group')) || 'Diamond Weight';
        var weightGroup = getByOptionName(nestedData.variant_data, weightGroupName);
        var weightOptions = getOptions(weightGroup);
        var selectedWeightObj = weightOptions.find(function (item) {
          return String(item.name || item.Name || '').trim() === selectedWeightValue;
        }) || null;

        if (selectedWeightObj) {
          nestedWeightPrice = Number(selectedWeightObj.price || 0) * 100;
          nestedWeightComparePrice = Number(selectedWeightObj.compare_at_price || 0) * 100;

          var goldGroup = getByOptionName(selectedWeightObj.optionData, 'Gold Purity');
          var goldOptions = getOptions(goldGroup);
          var selectedGoldObj = goldOptions.find(function (item) {
            return String(item.name || item.Name || '').trim() === selectedGoldPurityValue;
          }) || null;

          if (selectedGoldObj) {
            nestedGoldPurityPrice = Number(selectedGoldObj.price || 0) * 100;
            nestedGoldPurityComparePrice = Number(selectedGoldObj.compare_at_price || 0) * 100;
          }

          var colorGroup = getByOptionName(selectedWeightObj.optionData, 'Diamond Color');
          var colorOptions = getOptions(colorGroup);
          var selectedColorObj = colorOptions.find(function (item) {
            return String(item.name || item.Name || '').trim() === selectedColorValue;
          }) || null;

          if (selectedColorObj) {
            nestedColorPrice = Number(selectedColorObj.price || 0) * 100;
            nestedColorComparePrice = Number(selectedColorObj.compare_at_price || 0) * 100;

            var clarityGroup = getByOptionName(selectedColorObj.optionData, 'Diamond Clarity');
            var clarityOptions = getOptions(clarityGroup);
            var selectedClarityObj = clarityOptions.find(function (item) {
              return String(item.name || item.Name || '').trim() === selectedClarityValue;
            }) || null;

            if (selectedClarityObj) {
              nestedClarityPrice = Number(selectedClarityObj.price || 0) * 100;
              nestedClarityComparePrice = Number(selectedClarityObj.compare_at_price || 0) * 100;
            }
          }
        }
      }

      var nestedTotal = nestedWeightPrice + nestedColorPrice + nestedClarityPrice + nestedGoldPurityPrice;
      var nestedCompareTotal = nestedWeightComparePrice + nestedColorComparePrice + nestedClarityComparePrice + nestedGoldPurityComparePrice;

      var convertedNestedTotal = nestedTotal * Shopify.currency.rate;
      var convertedNestedCompareTotal = nestedCompareTotal * Shopify.currency.rate;

      if (convertedNestedTotal > 0) {
        mainprice = mainprice + convertedNestedTotal;
      }

      if (convertedNestedCompareTotal > 0) {
        maincompprice = maincompprice + convertedNestedCompareTotal;
      } else if (convertedNestedTotal > 0) {
        maincompprice = maincompprice + convertedNestedTotal;
      }
    }

    $('.price-sale').html(Shopify.formatMoney(mainprice));
    $('.price-compare').html(Shopify.formatMoney(maincompprice));

    setInputValue('input[name="properties[_DynamicPrice]"]', mainprice);

    if ($('input[name="properties[_totalPrice]"]').length > 0) {
      setInputValue('input[name="properties[_totalPrice]"]', mainprice / 100);
    }

    // The "was" price shown above, for the cart to show the same one
    // (empty when there is no real discount, so the cart shows none either)
    if ($('input[name="properties[_compareAtPrice]"]').length > 0) {
      setInputValue(
        'input[name="properties[_compareAtPrice]"]',
        maincompprice > mainprice ? Math.round(maincompprice) / 100 : ''
      );
    }
  });

  $(document).on('change', '.purity-radio', function () {
    triggerMainPriceUpdate();
  });

  $(document).on('change', '.customSizeSelector', function () {
    setInputValue('input[name="properties[Ring Size]"]', $(this).val() || '');
    setInputValue('input[name="properties[Wedding Band Size]"]', $(this).val() || '');
  });

  $(document).on('change', '.engraving_input', function () {
    setInputValue('input[name="properties[engraving]"]', $(this).val() || '');
  });

  $(document).on('change', '.bandwidth-percentage__radio', function () {
    var selectedBandwidth = $('.bandwidth-percentage__radio:checked');

    if (selectedBandwidth.length > 0) {
      setInputValue('input[name="properties[Bandwidth]"]', selectedBandwidth.attr('data-bandwidth') || '');

      if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
        setInputValue(
          'input[name="properties[_Bandwidth_Percentage]"]',
          selectedBandwidth.attr('data-percentage') || 0
        );
      }

      if ($('input[name="properties[_Bandwidth_Increase]"]').length > 0) {
        setInputValue(
          'input[name="properties[_Bandwidth_Increase]"]',
          selectedBandwidth.attr('data-percentage') || 0
        );
      }
    }

    triggerMainPriceUpdate();
  });

  $(document).on('change', '.custom-v1-option-radio', function () {
    var $selected = $(this);
    var optionHandle = $selected.attr('data-option-handle') || '';
    var optionLabel = $selected.attr('data-option-label') || '';
    var optionPrice = Number($selected.attr('data-price')) || 0;
    var $form = $selected.closest('form');

    if (!$form.length) {
      $form = $(document);
    }

    if (optionHandle) {
      $form.find('[data-custom-option-property="' + optionHandle + '"]').val(optionLabel).attr('value', optionLabel);

      $form.find('[data-custom-option-price-property="' + optionHandle + '"]').val(optionPrice * 100).attr('value', optionPrice * 100);
    }

    document.dispatchEvent(new Event('updateMainPrice'));
  });

  (function () {
    function qs(sel, ctx) {
      return (ctx || document).querySelector(sel);
    }

    function getSelectedRingSize() {
      var checked = $('.customSizeSelector option:selected');
      if (!checked.length) return '';

      var raw = String(checked.attr('value') || '').trim();
      if (!raw) return '';

      var normalized = raw.toLowerCase().replace(/\s+/g, ' ').trim();

      if (
        normalized === "us-don't know" ||
        normalized === "us-dont know" ||
        normalized === "don't know" ||
        normalized.indexOf('know') !== -1
      ) {
        return 'dont-know';
      }

      raw = raw.replace(/^us-/i, '').trim();
      return raw;
    }

    function getEngravingValue() {
      var input = qs('.engraving_input');
      return input ? String(input.value || '').trim() : '';
    }

    // Purity can come from three pickers: the old purity-options radios, the
    // flat v1_variant_data "Gold Purity" group, or the nested one.
    var V1_PURITY_SELECTOR =
      'input[name="gold-purity"], .custom-v1-option-radio[data-option-handle="gold-purity"], input[name^="nested_gold_purity_"]';

    function getSelectedPurity() {
      var checked = qs('input[name="gold-purity"]:checked') ||
        qs('.custom-v1-option-radio[data-option-handle="gold-purity"]:checked') ||
        qs('input[name^="nested_gold_purity_"]:checked');
      return checked ? String(checked.getAttribute('data-option-label') || checked.value || '').trim() : '';
    }

    // This ring's purity add-ons as "10K:0,14K:681,18K:1362", so the ring
    // builder charges what this page shows. Empty for the old purity-options
    // radios, which carry no prices (the builder keeps its flat add-on then).
    // compare: false -> the add-on prices; true -> their compare-at ("was") amounts,
    // falling back to the price where an option has none (as updateMainPrice does)
    function getPurityPrices(compare) {
      var pairs = [];
      document.querySelectorAll(V1_PURITY_SELECTOR).forEach(function (input) {
        if (input.name === 'gold-purity') return;
        var label = String(input.getAttribute('data-option-label') || input.value || '').trim();
        var price = Number(input.getAttribute('data-price'));
        if (compare) {
          var comparePrice = Number(input.getAttribute('data-compprice') || input.getAttribute('data-compare-price'));
          if (isFinite(comparePrice) && comparePrice > 0) price = comparePrice;
        }
        if (!label || !isFinite(price)) return;
        var pair = label + ':' + price;
        if (pairs.indexOf(pair) === -1) pairs.push(pair);
      });
      return pairs.join(',');
    }

    function getSelectedBandwidth() {
      var checked = qs('.bandwidth-percentage__radio:checked');
      if (!checked) return '';

      return String(checked.getAttribute('data-bandwidth') || checked.value || '').trim();
    }

    function getSelectedPriceIncrease() {
      var checked = qs('.bandwidth-percentage__radio:checked');
      if (!checked) return '';

      return String(checked.getAttribute('data-percentage') || '').trim();
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rb-builder-link]');
      if (!btn) return;

      e.preventDefault();

      var href = btn.getAttribute('href') || '';
      if (!href) return;

      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (err) {
        window.location.href = href;
        return;
      }

      var ringSize = getSelectedRingSize();
      var engraving = getEngravingValue();
      var purity = getSelectedPurity();
      var bandwidth = getSelectedBandwidth();
      var priceIncrease = getSelectedPriceIncrease();

      if (ringSize) {
        url.searchParams.set('ring_size', ringSize);
      } else {
        url.searchParams.delete('ring_size');
      }

      if (engraving) {
        url.searchParams.set('engraving', engraving);
      } else {
        url.searchParams.delete('engraving');
      }

      if (purity) {
        url.searchParams.set('gold_purity', purity);
      } else {
        url.searchParams.delete('gold_purity');
      }

      var purityPrices = getPurityPrices();
      if (purityPrices) {
        url.searchParams.set('purity_prices', purityPrices);
      } else {
        url.searchParams.delete('purity_prices');
      }

      // The setting's base (10K) price in dollars. The ring builder reads the price
      // from /products/<handle>.js; this is its fallback when that request fails,
      // so the setting is never priced at $0.
      var targetPriceEl = qs('.target-price');
      var basePriceCents = targetPriceEl ? Number(String(targetPriceEl.textContent || '').replace(/[^0-9]/g, '')) : NaN;
      if (isFinite(basePriceCents) && basePriceCents > 0) {
        url.searchParams.set('base_price', String(basePriceCents / 100));
      } else {
        url.searchParams.delete('base_price');
      }

      // Same fallback for the "was" price the cart shows: the setting's base
      // compare-at price and its purity add-ons' compare-at amounts
      var targetCompareEl = qs('.target-compare-at-price');
      var baseCompareCents = targetCompareEl ? Number(String(targetCompareEl.textContent || '').replace(/[^0-9]/g, '')) : NaN;
      if (isFinite(baseCompareCents) && baseCompareCents > 0) {
        url.searchParams.set('base_compare', String(baseCompareCents / 100));
      } else {
        url.searchParams.delete('base_compare');
      }
      var purityComparePrices = getPurityPrices(true);
      if (purityComparePrices) {
        url.searchParams.set('purity_compare_prices', purityComparePrices);
      } else {
        url.searchParams.delete('purity_compare_prices');
      }

      if (bandwidth) {
        url.searchParams.set('bandwidth', bandwidth);
      } else {
        url.searchParams.delete('bandwidth');
      }

      if (priceIncrease && priceIncrease !== '0') {
        url.searchParams.set('priceIncrease', priceIncrease);
      } else {
        url.searchParams.delete('priceIncrease');
      }

      window.location.href = url.toString();
    });
  })();

  /* UNIVERSAL NESTED METAFIELD LOGIC */
  (function () {
    function getByOptionName(arr, name) {
      if (!Array.isArray(arr)) return null;
      name = String(name || '').trim().toLowerCase();

      return arr.find(function (item) {
        return String(item.option_name || '').trim().toLowerCase() === name;
      }) || null;
    }

    function getOptions(group) {
      if (!group) return [];
      if (Array.isArray(group.Options)) return group.Options;
      if (Array.isArray(group.options)) return group.options;
      return [];
    }

    function getDeepLowestPrice(option) {
      var ownPrice = Number((option && option.price) || 0);

      if (!option || !Array.isArray(option.optionData) || !option.optionData.length) {
        return ownPrice;
      }

      var childLowest = null;

      option.optionData.forEach(function (group) {
        var childOptions = getOptions(group);
        if (!childOptions.length) return;

        var groupMin = null;

        childOptions.forEach(function (childOption) {
          var total = getDeepLowestPrice(childOption);
          if (groupMin === null || total < groupMin) {
            groupMin = total;
          }
        });

        if (groupMin !== null) {
          if (childLowest === null || groupMin < childLowest) {
            childLowest = groupMin;
          }
        }
      });

      return ownPrice + (childLowest !== null ? childLowest : 0);
    }

    function getLowestPriceOptionValue(options) {
      if (!Array.isArray(options) || !options.length) return '';

      var lowest = options[0];
      var lowestTotal = getDeepLowestPrice(lowest);

      options.forEach(function (item) {
        var total = getDeepLowestPrice(item);
        if (total < lowestTotal) {
          lowest = item;
          lowestTotal = total;
        }
      });

      return String(lowest.name || lowest.Name || '').trim();
    }

    function initNestedWrapper(wrapper) {
      if (!wrapper) return;

      var productId = wrapper.getAttribute('data-product-id');
      if (!productId) return;

      var jsonEl = wrapper.querySelector('[data-nested-variant-json]');
      if (!jsonEl) return;

      var data = null;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
      if (!data || !Array.isArray(data.variant_data)) return;

      function qs(sel, ctx) {
        return (ctx || wrapper).querySelector(sel);
      }

      function qsa(sel, ctx) {
        return Array.prototype.slice.call((ctx || wrapper).querySelectorAll(sel));
      }

      function getSelectedRadioValue(name) {
        var el = wrapper.querySelector('input[name="' + name + '"]:checked');
        return el ? String(el.value || '').trim() : '';
      }

      function getPropertyScope() {
        return wrapper.closest('form') || document;
      }

      function setNestedProperty(name, value) {
        var scope = getPropertyScope();

        scope.querySelectorAll('[data-nested-property="' + name + '"]').forEach(function (input) {
          input.value = value || '';
          input.setAttribute('value', value || '');
        });
      }

      function setNestedPriceProperty(name, value) {
        var scope = getPropertyScope();

        scope.querySelectorAll('[data-nested-price-property="' + name + '"]').forEach(function (input) {
          input.value = value || 0;
          input.setAttribute('value', value || 0);
        });
      }

      function setNestedComparePriceProperty(name, value) {
        var scope = getPropertyScope();

        scope.querySelectorAll('[data-nested-compare-price-property="' + name + '"]').forEach(function (input) {
          input.value = value || 0;
          input.setAttribute('value', value || 0);
        });
      }

      // "Diamond Weight", or "Gemstone Weight" on gemstone pieces (set by custom-variant-options.liquid)
      function getWeightGroup() {
        return getByOptionName(data.variant_data, wrapper.getAttribute('data-weight-group') || 'Diamond Weight');
      }

      function getSelectedWeightObject() {
        var weightGroup = getWeightGroup();
        var options = getOptions(weightGroup);
        var selectedWeight = getSelectedRadioValue('nested_diamond_weight_' + productId);

        return options.find(function (item) {
          return String(item.name || item.Name || '').trim() === selectedWeight;
        }) || null;
      }

      function getGroupFromWeight(weightObj, name) {
        return getByOptionName(weightObj && weightObj.optionData, name);
      }

      function getSelectedColorObject() {
        var weightObj = getSelectedWeightObject();
        var colorGroup = getGroupFromWeight(weightObj, 'Diamond Color');
        var colorOptions = getOptions(colorGroup);
        var selectedColor = getSelectedRadioValue('nested_diamond_color_' + productId);

        return colorOptions.find(function (item) {
          return String(item.name || item.Name || '').trim() === selectedColor;
        }) || null;
      }

      function toggleFieldset(wrapEl, show) {
        if (!wrapEl) return;
        var fieldset = wrapEl.closest('[data-nested-option-fieldset]');
        if (fieldset) {
          fieldset.style.display = show ? '' : 'none';
        }
      }

      function renderOptions(wrapEl, inputName, idPrefix, optionName, options, selectedValue) {
        if (!wrapEl) return;

        wrapEl.innerHTML = '';

        if (!Array.isArray(options) || !options.length) return;

        options.forEach(function (option, index) {
          var label = String(option.name || option.Name || '').trim();
          var price = Number(option.price || 0);
          var comparePrice = Number(option.compare_at_price || 0);
          var checked = String(label).trim() === String(selectedValue || '').trim();

          wrapEl.insertAdjacentHTML(
            'beforeend',
            `
            <div class="product-variant-input-radio nested-v1-option-item">
              <input
                class="nested-v1-option-radio"
                type="radio"
                id="${idPrefix}-${index}"
                name="${inputName}"
                value="${label.replace(/"/g, '&quot;')}"
                data-option-name="${optionName}"
                data-option-label="${label.replace(/"/g, '&quot;')}"
                data-price="${price}"
                data-compare-price="${comparePrice}"
                ${checked ? 'checked' : ''}
              >
              <label class="product-form__label nested-v1-option-label" for="${idPrefix}-${index}">
                <span class="text">${label}</span>
              </label>
            </div>
          `
          );
        });
      }

      function renderColorOptions(preferredColor) {
        var wrapEl = qs('[data-diamond-color-wrap]');
        var weightObj = getSelectedWeightObject();
        var colorGroup = getGroupFromWeight(weightObj, 'Diamond Color');
        var colorOptions = getOptions(colorGroup);

        if (!colorOptions.length) {
          if (wrapEl) wrapEl.innerHTML = '';
          toggleFieldset(wrapEl, false);
          setNestedProperty('Diamond Color', '');
          setNestedPriceProperty('Diamond Color', 0);
          setNestedComparePriceProperty('Diamond Color', 0);
          return;
        }

        toggleFieldset(wrapEl, true);

        var selectedColor = preferredColor || '';
        var exists = colorOptions.some(function (item) {
          return String(item.name || item.Name || '').trim() === selectedColor;
        });

        if (!exists) {
          selectedColor = getLowestPriceOptionValue(colorOptions);
        }

        renderOptions(
          wrapEl,
          'nested_diamond_color_' + productId,
          'nested-diamond-color-' + productId,
          'Diamond Color',
          colorOptions,
          selectedColor
        );
      }

      function renderClarityOptions(preferredClarity) {
        var wrapEl = qs('[data-diamond-clarity-wrap]');
        var colorObj = getSelectedColorObject();
        var clarityGroup = getByOptionName(colorObj && colorObj.optionData, 'Diamond Clarity');
        var clarityOptions = getOptions(clarityGroup);

        if (!clarityOptions.length) {
          if (wrapEl) wrapEl.innerHTML = '';
          toggleFieldset(wrapEl, false);
          setNestedProperty('Diamond Clarity', '');
          setNestedPriceProperty('Diamond Clarity', 0);
          setNestedComparePriceProperty('Diamond Clarity', 0);
          return;
        }

        toggleFieldset(wrapEl, true);

        var selectedClarity = preferredClarity || '';
        var exists = clarityOptions.some(function (item) {
          return String(item.name || item.Name || '').trim() === selectedClarity;
        });

        if (!exists) {
          selectedClarity = getLowestPriceOptionValue(clarityOptions);
        }

        renderOptions(
          wrapEl,
          'nested_diamond_clarity_' + productId,
          'nested-diamond-clarity-' + productId,
          'Diamond Clarity',
          clarityOptions,
          selectedClarity
        );
      }

      function renderGoldPurityOptions(preferredPurity) {
        var wrapEl = qs('[data-gold-purity-wrap]');
        var weightObj = getSelectedWeightObject();
        var goldGroup = getGroupFromWeight(weightObj, 'Gold Purity');
        var goldOptions = getOptions(goldGroup);

        if (!goldOptions.length) {
          if (wrapEl) wrapEl.innerHTML = '';
          toggleFieldset(wrapEl, false);
          setNestedProperty('Gold Purity', '');
          setNestedPriceProperty('Gold Purity', 0);
          setNestedComparePriceProperty('Gold Purity', 0);
          return;
        }

        toggleFieldset(wrapEl, true);

        var selectedPurity = preferredPurity || '';
        var exists = goldOptions.some(function (item) {
          return String(item.name || item.Name || '').trim() === selectedPurity;
        });

        if (!exists) {
          selectedPurity = getLowestPriceOptionValue(goldOptions);
        }

        renderOptions(
          wrapEl,
          'nested_gold_purity_' + productId,
          'nested-gold-purity-' + productId,
          'Gold Purity',
          goldOptions,
          selectedPurity
        );
      }

      function syncNestedProperties() {
        var weightEl = qs('input[name="nested_diamond_weight_' + productId + '"]:checked');
        var colorEl = qs('input[name="nested_diamond_color_' + productId + '"]:checked');
        var clarityEl = qs('input[name="nested_diamond_clarity_' + productId + '"]:checked');
        var goldEl = qs('input[name="nested_gold_purity_' + productId + '"]:checked');

        if (weightEl) {
          var weightComparePrice = 0;
          var selectedWeightValue = String(weightEl.value || '').trim();
          var weightGroup = getWeightGroup();
          var weightOptions = getOptions(weightGroup);
          var selectedWeightObj = weightOptions.find(function (item) {
            return String(item.name || item.Name || '').trim() === selectedWeightValue;
          }) || null;

          if (selectedWeightObj) {
            weightComparePrice = (Number(selectedWeightObj.compare_at_price) || 0) * 100;
          }

          setNestedProperty('Diamond Weight', weightEl.getAttribute('data-option-label') || '');
          setNestedPriceProperty('Diamond Weight', (Number(weightEl.getAttribute('data-price')) || 0) * 100);
          setNestedComparePriceProperty('Diamond Weight', weightComparePrice);
        } else {
          setNestedProperty('Diamond Weight', '');
          setNestedPriceProperty('Diamond Weight', 0);
          setNestedComparePriceProperty('Diamond Weight', 0);
        }

        if (colorEl) {
          setNestedProperty('Diamond Color', colorEl.getAttribute('data-option-label') || '');
          setNestedPriceProperty('Diamond Color', (Number(colorEl.getAttribute('data-price')) || 0) * 100);
          setNestedComparePriceProperty('Diamond Color', (Number(colorEl.getAttribute('data-compare-price')) || 0) * 100);
        } else {
          setNestedProperty('Diamond Color', '');
          setNestedPriceProperty('Diamond Color', 0);
          setNestedComparePriceProperty('Diamond Color', 0);
        }

        if (clarityEl) {
          setNestedProperty('Diamond Clarity', clarityEl.getAttribute('data-option-label') || '');
          setNestedPriceProperty('Diamond Clarity', (Number(clarityEl.getAttribute('data-price')) || 0) * 100);
          setNestedComparePriceProperty('Diamond Clarity', (Number(clarityEl.getAttribute('data-compare-price')) || 0) * 100);
        } else {
          setNestedProperty('Diamond Clarity', '');
          setNestedPriceProperty('Diamond Clarity', 0);
          setNestedComparePriceProperty('Diamond Clarity', 0);
        }

        if (goldEl) {
          setNestedProperty('Gold Purity', goldEl.getAttribute('data-option-label') || '');
          setNestedPriceProperty('Gold Purity', (Number(goldEl.getAttribute('data-price')) || 0) * 100);
          setNestedComparePriceProperty('Gold Purity', (Number(goldEl.getAttribute('data-compare-price')) || 0) * 100);
        } else {
          setNestedProperty('Gold Purity', '');
          setNestedPriceProperty('Gold Purity', 0);
          setNestedComparePriceProperty('Gold Purity', 0);
        }
      }

      function getPreferredDefaultWeight() {
        var inputs = qsa('input[name="nested_diamond_weight_' + productId + '"]');
        if (!inputs.length) return null;

        var checkedInput = inputs.find(function (input) {
          return input.checked;
        });
        if (checkedInput) return checkedInput;

        var lowest = inputs[0];
        inputs.forEach(function (input) {
          if (Number(input.getAttribute('data-price') || 0) < Number(lowest.getAttribute('data-price') || 0)) {
            lowest = input;
          }
        });

        return lowest;
      }

      function renderAll() {
        renderColorOptions(getSelectedRadioValue('nested_diamond_color_' + productId));
        renderClarityOptions(getSelectedRadioValue('nested_diamond_clarity_' + productId));
        renderGoldPurityOptions(getSelectedRadioValue('nested_gold_purity_' + productId));
        syncNestedProperties();
        document.dispatchEvent(new Event('updateMainPrice'));
      }

      var defaultWeightEl = getPreferredDefaultWeight();
      if (defaultWeightEl) {
        defaultWeightEl.checked = true;
      }

      renderAll();

      wrapper.addEventListener('change', function (e) {
        if (e.target.matches('input[name="nested_diamond_weight_' + productId + '"]')) {
          renderAll();
        }

        if (e.target.matches('input[name="nested_diamond_color_' + productId + '"]')) {
          renderClarityOptions(getSelectedRadioValue('nested_diamond_clarity_' + productId));
          syncNestedProperties();
          document.dispatchEvent(new Event('updateMainPrice'));
        }

        if (
          e.target.matches('input[name="nested_diamond_clarity_' + productId + '"]') ||
          e.target.matches('input[name="nested_gold_purity_' + productId + '"]')
        ) {
          syncNestedProperties();
          document.dispatchEvent(new Event('updateMainPrice'));
        }
      });
    }

    function initAllNestedWrappers() {
      document.querySelectorAll('[data-nested-v1-wrapper]').forEach(function (wrapper) {
        initNestedWrapper(wrapper);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllNestedWrappers, { once: true });
    } else {
      initAllNestedWrappers();
    }
  })();

  $(document).ready(function () {
    $('.custom-v1-option-fieldset').each(function () {
      var $fieldset = $(this);
      var optionHandle = $fieldset.attr('data-option-handle');
      var $selected = $fieldset.find('.custom-v1-option-radio:checked');

      if ($selected.length > 0) {
        var optionLabel = $selected.attr('data-option-label') || '';
        var optionPrice = (Number($selected.attr('data-price')) || 0) * 100;

        $('[data-custom-option-property="' + optionHandle + '"]').each(function () {
          $(this).val(optionLabel).attr('value', optionLabel);
        });

        $('[data-custom-option-price-property="' + optionHandle + '"]').each(function () {
          $(this).val(optionPrice).attr('value', optionPrice);
        });
      }
    });

    if ($('.customSizeSelector').length > 0) {
      setInputValue('input[name="properties[Ring Size]"]', $('.customSizeSelector').val() || '');
      setInputValue('input[name="properties[Wedding Band Size]"]', $('.customSizeSelector').val() || '');
    }

    if ($('.engraving_input').length > 0) {
      setInputValue('input[name="properties[engraving]"]', $('.engraving_input').val() || '');
    }

    triggerMainPriceUpdate();

    $('.necklace-size-option').change(function () {
      var size = $('.necklace-size-option:checked').val();
      $('input[name="properties[Necklace Size]"]').val(size);
    });

    $('.bracelet-size-option').change(function () {
      var size = $('.bracelet-size-option:checked').val();
      $('input[name="properties[Bracelet Size]"]').val(size);
    });
  });
})();

/* ------------------------------------------------------------------
   Persist Gold Purity across metal changes.
   Each metal color is a separate product, so switching metal is a full
   page navigation that resets purity to the cheapest option (10K).
   We remember the shopper's purity for the browsing session
   (sessionStorage) and re-apply it on load by re-firing the theme's own
   change handlers, so price + properties[Gold Purity] stay in sync.

   Covers BOTH purity UIs:
     - .purity-radio                                  (purity-options.liquid)
     - .custom-v1-option-radio[data-option-handle="gold-purity"]
                                                  (custom-variant-options.liquid)
------------------------------------------------------------------ */
(function () {
  if (window.__nsPurityPersistInit) return;
  window.__nsPurityPersistInit = true;

  var KEY = 'ns_gold_purity';
  var SELECTOR = '.purity-radio, .custom-v1-option-radio[data-option-handle="gold-purity"]';

  function norm(v) { return String(v || '').trim().toUpperCase().replace(/\s+/g, ''); }

  function valueOf(radio) {
    return norm(radio.getAttribute('data-option-label') || radio.value);
  }

  // Remember the shopper's purity selection for this session.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SELECTOR)) {
      try { sessionStorage.setItem(KEY, valueOf(t)); } catch (err) {}
    }
  }, true);

  // Some categories (necklaces, bracelets, earrings) wire purity into an
  // interdependent variant with size / diamond color / clarity / weight.
  // Auto-firing a purity change there cascades a reset of those sibling
  // selections, so we only auto-restore where purity stands alone (rings,
  // eternity / wedding bands). Detect the interdependent controls by their
  // actual inputs (not CSS) and skip restore when present.
  function hasInterdependentOptions() {
    return !!document.querySelector(
      'input[name="alignment"], input.nested-v1-option-radio, input[name^="nested_gold_purity"]'
    );
  }

  // Re-apply the saved selection when a product page loads.
  function restorePurity() {
    var saved;
    try { saved = sessionStorage.getItem(KEY); } catch (err) { return; }
    if (!saved) return;
    saved = norm(saved);

    if (hasInterdependentOptions()) return;

    var radios = document.querySelectorAll(SELECTOR);
    if (!radios.length) return;

    var match = null;
    radios.forEach(function (r) { if (valueOf(r) === saved) match = r; });
    if (!match || match.checked) return;

    match.checked = true;
    // Bubbles to the theme's delegated change handlers, which update the
    // hidden Gold Purity property and recompute the displayed price.
    match.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restorePurity);
  } else {
    restorePurity();
  }
})();

/* ------------------------------------------------------------------
   Persist NESTED variant selections across metal changes
   (necklaces / bracelets / earrings).

   These products use a nested variant:
     Diamond Weight (parent) -> renders Diamond Color + Gold Purity
     Diamond Color           -> renders Diamond Clarity
   plus a size radio group (name="alignment").

   Each metal color is a SEPARATE product, so switching metal is a full
   page navigation that resets the whole configuration. We remember the
   shopper's full selection for the browsing session and, on the next
   product page, replay it in dependency order by firing the theme's own
   change handlers. That reuses the theme's nested re-render + property +
   price logic (assets/variant-select.js initNestedWrapper), so nothing
   is reimplemented. Values that don't exist for the new metal are simply
   left at their default.
------------------------------------------------------------------ */
(function () {
  if (window.__nsNestedPersistInit) return;
  window.__nsNestedPersistInit = true;

  var KEY = 'ns_nested_config';

  // Replay/dependency order: parent first, then its children, then size.
  var FIELDS = [
    { key: 'weight',  sel: 'input[name^="nested_diamond_weight_"]' },
    { key: 'color',   sel: 'input[name^="nested_diamond_color_"]' },
    { key: 'clarity', sel: 'input[name^="nested_diamond_clarity_"]' },
    { key: 'purity',  sel: 'input[name^="nested_gold_purity_"]' },
    { key: 'size',    sel: 'input[name="alignment"]' }
  ];

  var isRestoring = false;

  function labelOf(el) {
    return String((el.getAttribute && el.getAttribute('data-option-label')) || el.value || '').trim();
  }

  function isNestedProduct() {
    return !!document.querySelector('[data-nested-v1-wrapper]');
  }

  // The design (custom.v1_style_id) this page belongs to. Metal versions of one
  // design share it; anything else has a different one.
  function currentStyleId() {
    var wrapper = document.querySelector('[data-nested-v1-wrapper]');
    return wrapper ? String(wrapper.getAttribute('data-style-id') || '').trim() : '';
  }

  function snapshot() {
    // Saved with its design, so restore() can apply it to that design only
    var cfg = { style: currentStyleId() };
    FIELDS.forEach(function (f) {
      var el = document.querySelector(f.sel + ':checked');
      if (el) cfg[f.key] = labelOf(el);
    });
    return cfg;
  }

  // Remember the shopper's full configuration on any real user change.
  document.addEventListener('change', function (e) {
    if (isRestoring) return;
    var t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('.nested-v1-option-radio, input[name^="nested_diamond_weight_"], input[name="alignment"]')) return;
    if (!isNestedProduct()) return;
    try { sessionStorage.setItem(KEY, JSON.stringify(snapshot())); } catch (err) {}
  }, true);

  function applyField(f, wanted) {
    if (!wanted) return;
    var radios = document.querySelectorAll(f.sel);
    if (!radios.length) return;
    var match = null;
    radios.forEach(function (r) {
      if (!match && labelOf(r).toLowerCase() === String(wanted).trim().toLowerCase()) match = r;
    });
    if (!match || match.checked) return;
    match.checked = true;
    // Bubbles to the theme's nested change handler, which re-renders the
    // child options and updates the hidden properties + price.
    match.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function restore() {
    if (!isNestedProduct()) return;
    var cfg;
    try { cfg = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) { return; }
    if (!cfg) return;

    // Only carry choices over between metal versions of the SAME design. Without
    // this, a 15 ct necklace choice opened the next bracelet at 15 ct and nearly
    // double its starting price. A save without a design (older format), or a
    // page without one, is not restored.
    var styleId = currentStyleId();
    if (!styleId || !cfg.style || cfg.style !== styleId) return;

    isRestoring = true;
    // Each dispatch re-renders the child groups synchronously, so the next
    // iteration sees the freshly rendered radios and can re-apply them.
    FIELDS.forEach(function (f) { applyField(f, cfg[f.key]); });

    // The size property is written by a jQuery $(document).ready handler,
    // which can bind AFTER this restore runs (its change wouldn't be caught).
    // Set the hidden size property directly so the cart is always correct.
    var sizeEl = document.querySelector('input[name="alignment"]:checked');
    if (sizeEl) {
      var sizeVal = String(sizeEl.value || '').trim();
      document
        .querySelectorAll('input[name="properties[Bracelet Size]"], input[name="properties[Necklace Size]"]')
        .forEach(function (input) { input.value = sizeVal; });
    }
    isRestoring = false;

    // We intentionally do NOT overwrite the saved config here: keep the
    // shopper's desired values so a value missing on this metal can still
    // be re-applied on another metal that offers it.
    try { document.dispatchEvent(new Event('updateMainPrice')); } catch (err) {}
  }

  function schedule() {
    // Defer past the theme's own nested init (initAllNestedWrappers), which
    // renders the first pass and binds the change handlers we rely on.
    setTimeout(restore, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();